import { type FC, useCallback } from "react";

import { CrossIcon } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../shared/components";
import { InlineButtonWrapper } from "../../shared/styles";

import { Tag, TagName, TagsWrapper, removeTag } from "./Tags.styles";

interface TagsContainer {
    tagsList: readonly string[];
    onRemoveTag?: (name: string) => void;
    unremovable?: boolean;
}

export const TagsContainer: FC<TagsContainer> = ({ tagsList = [], onRemoveTag, unremovable = false }) => {
    const onClickRemove = useCallback(
        (name: string) => () => {
            onRemoveTag?.(name);
        },
        [onRemoveTag],
    );

    if (tagsList.length === 0) {
        return null;
    }

    return (
        <TagsWrapper>
            <Flexbox flexWrap="wrap">
                {tagsList.map((name) => (
                    <Tag data-testid="tag-chip" key={name}>
                        <TagName>{name}</TagName>
                        {!unremovable && (
                            <InlineButtonWrapper
                                onKeyDown={onClickRemove(name)}
                                onClick={onClickRemove(name)}
                                role="button"
                                tabIndex={0}
                            >
                                <CrossIcon className={removeTag} size={12} />
                            </InlineButtonWrapper>
                        )}
                    </Tag>
                ))}
            </Flexbox>
        </TagsWrapper>
    );
};
